<div class="attachment-icon">
  <svg>
    <use xlink:href="#attachment-file"></use>
  </svg>
</div>

<a [attr.href]="href()" class="filename" appTruncateFilename target="_blank">{{ filename() }}</a>

@if (filesize()) {
  <span class="filesize">{{ filesize() }}</span>
}

@if (isUploading()) {
  <div class="progress-container">
    <mat-progress-spinner
      class="app-spinner-primary"
      [value]="progress()"
      [diameter]="32"
      mode="determinate"></mat-progress-spinner>
    <button type="button" class="btn" [disabled]="disabled()" (click)="handleDelete()">
      <svg>
        <use xlink:href="#dialog-close"></use>
      </svg>
    </button>
  </div>
} @else {
  <button type="button" class="btn" [disabled]="disabled()" (click)="handleDelete()">
    <svg>
      <use xlink:href="#dialog-close"></use>
    </svg>
  </button>
}
